export default "__VITE_ASSET__su2nafew__"